import { useMemo, useState } from "react";
import { ApiFactory } from "../../core/config/ApiFactory";
import { useFetch } from "../../core/hooks/useFetch";
import { StatusCampanha } from "../interfaces/ICampanha";

export const useFetchCampanhas = () => {
    const apiEstabelecimento = useMemo(() => ApiFactory.getApi("MS_ESTABELECIMENTOS"), []);
    const baseUrl = "/campanhas";
    const [nome, setNome] = useState("");
    const [status, setStatus] = useState<StatusCampanha | "">("");
    const [inicioAs, setInicioAs] = useState("");
    const [terminoAs, setTerminoAs] = useState("");
    const [url, setUrl] = useState(baseUrl);

    const buildUrl = () => {
        const params = new URLSearchParams();
        if(nome.trim()) params.append("nome", nome.trim());
        if(status) params.append("status", status);
        if(inicioAs) params.append("inicioAs", inicioAs);
        if(terminoAs) params.append("terminoAs", terminoAs);
        const query = params.toString();
        return query ? `${baseUrl}?${query}` : baseUrl;
    };

    const handleLimpar = () => {
        setNome("");
        setStatus("");
        setInicioAs("");
        setTerminoAs("");
        setUrl(baseUrl);
    };

    const handleFiltrar = () => setUrl(buildUrl());
    const { data: dados, isLoading, handleRefresh } = useFetch(apiEstabelecimento, url);

    return {
        dados,
        isLoading,
        handleRefresh,
        handleLimpar,
        handleFiltrar,
        nome,
        setNome,
        status,
        setStatus,
        inicioAs,
        setInicioAs,
        terminoAs,
        setTerminoAs
    };
};
